import React from 'react';
import GestorLayout from '../../components/GestorLayout';
import { Button } from '../../components/ui/button';
import { Plus, Archive, QrCode } from 'lucide-react';
import { useBolsaTarefas } from './bolsa-tarefas/useBolsaTarefas';
import { KanbanBoard } from './bolsa-tarefas/KanbanBoard';
import { TarefaFormDialog } from './bolsa-tarefas/TarefaFormDialog';
import { CategoriasModal } from './bolsa-tarefas/CategoriasModal';
import { ConfigOperacoesModal } from './bolsa-tarefas/ConfigOperacoesModal';
import { CategoryFilter } from './bolsa-tarefas/CategoryFilter';

// Conteudo exportavel para ser usado dentro de outras paginas (ex: Planeamento com Tabs)
export function BolsaTarefasContent() {
  const h = useBolsaTarefas();

  return (
    <div className="p-6 bg-stone-50 min-h-[600px]" data-testid="tarefas-pontuais-content">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-xl font-heading font-bold text-stone-800">Tarefas Pontuais</h2>
          <p className="text-stone-500 text-sm">Tarefas recorrentes - ativas aparecem permanentemente para operadores</p>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant={h.showArquivadas ? "default" : "outline"}
            onClick={() => h.setShowArquivadas(!h.showArquivadas)}
            size="sm" className="rounded-full"
            data-testid="toggle-arquivadas-content-btn"
          >
            <Archive className="h-4 w-4 mr-1" />
            {h.showArquivadas ? 'Esconder Arquivadas' : 'Ver Arquivadas'}
          </Button>
          <Button onClick={h.descarregarQRCode} variant="outline" className="rounded-full"
            data-testid="qrcode-tarefas-btn" title="Descarregar folha A6 com QR Code para operadores">
            <QrCode className="h-4 w-4 mr-2" />QR Code
          </Button>
          <Button onClick={h.abrirNovaTarefa} className="rounded-full bg-primary hover:bg-primary/90"
            data-testid="nova-tarefa-btn">
            <Plus className="h-4 w-4 mr-2" />Nova Tarefa
          </Button>
        </div>
      </div>

      <CategoryFilter
        filtroCategoria={h.filtroCategoria} setFiltroCategoria={h.setFiltroCategoria}
        categoriasTarefas={h.categoriasTarefas} onOpenCategorias={() => h.setShowCategoriasModal(true)}
      />

      <CategoriasModal
        open={h.showCategoriasModal} onOpenChange={h.setShowCategoriasModal}
        categoriasTarefas={h.categoriasTarefas}
        editingCat={h.editingCat} setEditingCat={h.setEditingCat}
        novaCatNome={h.novaCatNome} setNovaCatNome={h.setNovaCatNome}
        novaCatCor={h.novaCatCor} setNovaCatCor={h.setNovaCatCor}
        onCriar={h.criarCategoria} onAtualizar={h.atualizarCategoria} onEliminar={h.eliminarCategoria}
        operacoesDisponiveis={h.operacoesDisponiveis}
      />

      <KanbanBoard
        tarefasPorEstado={h.tarefasPorEstado} showArquivadas={h.showArquivadas}
        dragOverColumn={h.dragOverColumn} onDragOver={h.handleDragOver}
        onDragLeave={h.handleDragLeave} onDrop={h.handleDrop}
        draggedTarefa={h.draggedTarefa} onDragStart={h.handleDragStart} onDragEnd={h.handleDragEnd}
        categoriasTarefas={h.categoriasTarefas} operadores={h.operadores}
        onDuplicate={h.duplicarTarefa} onEdit={h.abrirEditarTarefa}
        onArchive={h.arquivarTarefa} onUnarchive={h.desarquivarTarefa} onDelete={h.eliminarTarefa}
        onConclusaoUpdated={h.carregarDados}
      />

      <TarefaFormDialog
        open={h.showDialog} onOpenChange={h.setShowDialog}
        editingTarefa={h.editingTarefa} formData={h.formData} setFormData={h.setFormData}
        categoriasTarefas={h.categoriasTarefas} operacoesSugeridas={h.operacoesSugeridas}
        operacoesDisponiveis={h.operacoesDisponiveis} operadoresFiltrados={h.operadoresFiltrados}
        showOperacoesSelector={h.showOperacoesSelector} setShowOperacoesSelector={h.setShowOperacoesSelector}
        onSave={h.guardarTarefa} onToggleSugerida={h.toggleOperacaoSugerida}
        onAddOperacao={h.adicionarOperacao} onRemoveOperacao={h.removerOperacao}
        onOpenConfig={h.abrirConfigModal}
      />

      <ConfigOperacoesModal
        open={h.showConfigModal} onOpenChange={h.setShowConfigModal}
        configOperacoes={h.configOperacoes} operacoesDisponiveis={h.operacoesDisponiveis}
        onRemove={h.removerOperacaoConfig} onAdd={h.adicionarOperacaoConfig} onSave={h.guardarConfigOperacoes}
      />
    </div>
  );
}

// Componente principal com GestorLayout (para rota standalone)
export default function BolsaTarefas() {
  return (
    <GestorLayout>
      <BolsaTarefasContent />
    </GestorLayout>
  );
}
